export default "__VITE_ASSET__36b04857__"